/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Rehab_LeadInputs */

const en_for_whom_rehab_lead = /** @type {(inputs: For_Whom_Rehab_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming back from an injury.`)
};

const pl_for_whom_rehab_lead = /** @type {(inputs: For_Whom_Rehab_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powrót po kontuzji.`)
};

/**
* | output |
* | --- |
* | "Coming back from an injury." |
*
* @param {For_Whom_Rehab_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_rehab_lead = /** @type {((inputs?: For_Whom_Rehab_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Rehab_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_rehab_lead(inputs)
	return en_for_whom_rehab_lead(inputs)
});